<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" placement="right" size="sm" hide-close header-class="!hidden">

			<!-- stream types -->
			<div class="modal-container">
				<div class="px-3 mb-2 mt-100 mobile-header flex flex-wrap items-center">
					<div class="w-2/3">
						<router-link :to="{ path: '/dashboard' }" class="modal-logo">
							<img height="32px" class="logo-icon" :src="require('@/assets/castr.svg')"
								alt="Streaming Dashboard - Castr"   />
							<div class="logo-icon-dot" />
						</router-link>
						<h3 class="modal-title block md:hidden">
							Create New
						</h3>
					</div>
					<div class="text-right w-1/3">
						<FormButton type="light" :isIcon="true" class="px-2 btn-close" @click="dismiss">
							<img src="@/assets/images/menu-close.svg" alt="Menu close">
						</FormButton>
					</div>
				</div>
				<div class="flex flex-wrap">
					<div class="w-full">
						<h3 class="modal-title-style2">
							Create New
						</h3>
						<div v-for="streamTypeDef in this.filterStream()" :key="streamTypeDef.type"
							:class="{ active: selectedStreamType === streamTypeDef.type }"
							:id="((memberPermission && (streamTypeDef.type === 'live') && !memberPermission.liveStreamManage) || (memberPermission && (streamTypeDef.type === 'restream') && !memberPermission.recordedStreamManage)) ? ('member-disabled_' + streamTypeDef.type) : ''"
							class="flex stream-item items-start" @click="selectStreamType(streamTypeDef.type)">
							<div class="stream-item__icon mr-3">
								<icon-base v-if="streamTypeDef.type === 'restream'" class="text-white" width="24" height="24" width-view-box="16" height-view-box="16">
									<icon-multistream />
								</icon-base>
								<icon-base v-if="streamTypeDef.type === 'live'" fill="none" class="text-white" width="24" height="24" width-view-box="24" height-view-box="24">
									<icon-live-circle />
								</icon-base>
							</div>
							<div class="stream-item__desc">
								<h5 class="stream-item__title text-500" :class="[streamTypeDef.type]">
									{{ streamTypeDef.title }}
								</h5>
								<p class="stream-item__p text-dark-7 mb-0">{{ streamTypeDef.description }}</p>
							</div>
							<Tooltip><span class="inline-block"></span><template #content>
								<span class="text-dark-8 text-small">
									You don’t have permission. Contact the team owner at <a class="text-dark-8 text-small"
										:href="'mailto:' + userEmail">{{ userEmail }}</a> to gain access.</span>
							</template></Tooltip>
						</div>
					</div>
				</div>
			</div>

			<div class="modal-step-2">
				<!-- stream creation form  -->
				<section :class="selectedStreamType ? 'showform' : 'hideform'" class="view-stage-item second-modal">
					<div>
						<div v-if="error">
							<div v-if="error.role">
								<div class="bg-dark-3 flex flex-wrap gap-0">
									<div class="p-3 w-full">
										<p class="mb-2">
											You do not have an active {{ (selectedStreamType === 'restream') ? 'Multistream' :
												(selectedStreamType !== 'vod' ? ' Live Stream' : '') }} subscription.</p>
										<p class="mb-0 text-s-m text-dark-7">Would you like to activate our 7-day trial?</p>
									</div>
								</div>

								<div v-if="trialError" class="alert alert-danger">{{ trialError.message }}</div>
								<div class="text-right">
									<div v-if="trialProcessing">
										<FormProgress :value="100" :max="100" animated class="w-full" />
									</div>
									<div v-else>
										<div class="flex flex-wrap">
											<div class="px-5 mt-4 w-full">
												<FormButton :disabled="trialProcessing" type="main" size="md" class="w-full mb-3"
													@click="forceActivateTrial"><span v-if="!trialProcessing">Activate Trial</span><span
														v-else>Activating... Please wait</span></FormButton>
												<FormButton type="link" size="md" class="text-dark-7 w-full mb-3"
													:to="`/subscribe?category=${selectedStreamType}`">
													Want more options?
												</FormButton>
												<FormButton type="secondary" class="w-full" size="md" @click="dismiss">Cancel</FormButton>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- form -->
						<div v-show="operational" class="mt-200">
							<div class="px-3 mb-2 flex md:hidden mobile-header flex-wrap gap-0 items-center" v-if="selectedStreamType"
							>
								<div class="w-1/6">
									<FormButton type="light" :isIcon="true" size="sm" class="text-dark-7 px-2" @click="selectedStreamType = null">
										<icon-base fill="none" width="8" height="14" width-view-box="8" height-view-box="14">
											<icon-chevron-left-thin />
										</icon-base>
									</FormButton>
								</div>
								<div class="w-full">
									<h3 class="modal-title block md:hidden">
										New {{ selectedStreamTypeDef.title }}
									</h3>
								</div>
								<div class="text-right w-1/6">
									<FormButton type="light" :isIcon="true" class="px-2 btn-close" @click="dismiss">
										<img src="@/assets/images/menu-close.svg" alt="Menu close">
									</FormButton>
								</div>
							</div>
							<div class="flex flex-wrap">
								<div class="px-5 py-2 w-full">
									<div v-if="selectedStreamType" class="stream-type-info">
										<h4 class="text-s-l hidden md:block text-500">{{ selectedStreamTypeDef.title }}</h4>
										<p class="text-s-m text-dark-7 mt-2 md:mt-0 mb-0">{{ selectedStreamTypeDef.description2 }}</p>
									</div>
								</div>
							</div>
							<div class="flex flex-wrap">
								<div class="w-full">
									<Alert v-if="error && !error.role" type="error" class="text-left mx-4">
										<div v-html="error.message"></div>
										<div v-if="error.subscription" class="text-left">
											<a href="/app/subscribe"><strong>upgrade now</strong></a>
										</div>
									</Alert>
								</div>
							</div>
							<div class="flex flex-wrap">
								<div class="px-5 py-2 w-full">
									<FormInput v-model="channel.name" label="Stream Name *" placeholder="#stream_name"
										@keypress="onInputChange('name')" :helper="formErrors.name ? 'specify stream name' : null" />
								</div>
							</div>
							<div class="flex flex-wrap">
								<div
									class="w-full px-5 py-2"
									v-show="(contextualRegionList.length > 0 && selectedStreamType === 'live') || contextualRegionList.length > 1"
								>
									<label class="text-s-s w-full">
										Hosting Region *
									</label>
									<StreamRegion class="relative" :stream="newStreamComputed"
										@switch-stream-region="selectRegion" />
									<p v-show="formErrors.region" class="text-warning pl-1">
										specify hosting region
									</p>
								</div>
							</div>
						</div>
						<!-- <br> -->
					</div>

					<!-- view footer -->
					<div class="flex flex-wrap">
						<div class="px-5 w-full" v-show="operational || processing">
							<form-button class="w-full mt-3 justify-center" v-if="processing" disabled>
								<Spinner text="Creating..." classes="text-dark-8" spinner-color="var(--c-dark-8)" spinner-size="15px" />
							</form-button>

							<div v-else class="w-full">
								<form-button class="w-full mt-3 justify-center" v-if="selectedStreamType" @click="onSaveChannel">
									Create {{ selectedStreamTypeDef.title }}
								</form-button>
								<form-button type="secondary" class="w-full mt-3 justify-center" v-if="selectedStreamType"
									@click="unselectStreamType">
									Cancel
								</form-button>
							</div>
						</div>
					</div>
				</section>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import FormProgress from '@/components/Atoms/FormProgress.vue'
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import Tooltip from '@/components/Atoms/Tooltip.vue'
import _ from 'lodash';
import Spinner from "@/components/ui/Spinner.vue";
import StreamService from '@/services/StreamService';
import IconBase from '@/components/icon/IconBase.vue';
import IconLivestream from '@/components/icon/IconLivestream.vue';
import IconMultistream from '@/components/icon/IconMultistream.vue';
import IconIpcam from '@/components/icon/IconIpcam.vue';
import IconSchedulestream from '@/components/icon/IconSchedulestream.vue';
import IconVodChannel from '@/components/icon/IconVodChannel.vue';
import IconLiveCircle from '@/components/icon/IconLiveCircle.vue';
import IconChevronLeftThin from '@/components/icon/IconChevronLeftThin.vue';
import SubscriptionService from '@/services/SubscriptionService';
import StreamRegion from '../ui/StreamRegion.vue';
import FormInput from '../Atoms/FormInput.vue';
import FormButton from '../Atoms/FormButton.vue';
import Alert from '@/components/Atoms/Alert.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'AddStreamModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-stream',
	components: {
		FormProgress,
		ModalBox,
		Tooltip,
		Alert,
		Spinner,
		IconBase,
		IconLivestream,
		IconMultistream,
		IconIpcam,
		IconSchedulestream,
		IconVodChannel,
		IconLiveCircle,
		IconChevronLeftThin,
		StreamRegion,
		FormInput,
		FormButton,
	},
	data() {
		return {
			processing: false,
			trialProcessing: false,
			error: null,
			trialError: null,
			operational: true,
			viewStage: 1,
			selectedStreamType: null,
			userSubscription: null,
			channel: {
				name: null,
				region: null
			},
			selectedRegion: null,
			regions: [],
			formErrors: { name: false, region: false },
			streamTypeList: [
				{
					type: 'restream',
					title: 'Multistream',
					description: 'Stream To Multiple Sites',
					description2: 'Stream your videos to multiple social platforms and destinations at the same time.',
					icon: require('@/assets/images/simulcast-plan.svg') // eslint-disable-line no-undef
				},
				{
					type: 'live',
					title: 'Live Stream',
					description: 'Livestream to websites with your player, stream to social media, and convert livestreams to on-demand videos — all in one place',
					description2: 'Livestream videos on your own website and multiple stream destinations.',
					icon: require('@/assets/images/live-plan.svg') // eslint-disable-line no-undef
				},
			],
			onInputChange(prop) {
				this.formErrors[prop] = false;
			}
		};
	},
	props: {
		typeFromBilling: {
			type: String,
		}
	},
	computed: {
		userEmail() {
			return this.$store.state.User.email;
		},
		subscriptions() {
			return this.$store.state.User.subscriptions;
		},
		deploymentRegions() {
			return this.$store.state.User.deploymentRegions;
		},
		contextualRegionList() {
			const stype = this.selectedStreamType;
			// we don't ask scheduled region from user
			if (stype === 'scheduled') {
				return [];
			}

			return stype
				? this.regions.filter(r => r.platforms.indexOf('restream') > -1)
				: [];
		},
		selectedStreamTypeDef() {
			return this.streamTypeList.find(
				e => e.type === this.selectedStreamType
			);
		},
		streamTypeSubscriptionCategory() {
			let subCat = this.selectedStreamType;
			if (subCat === 'scheduled') {
				subCat = 'restream';
			}

			return subCat || 'restream';
		},
		activeTeam() {
			return this.$store.state.User.activatedTeam;
		},
		memberPermission() {
			return this.activeTeam && this.$store.state.User.memberPermission;
		},
		newStreamComputed() {
			const newStream = {}
			newStream.uiRegion = this.selectedRegion
			newStream.type = this.selectedStreamType
			return newStream
		}
	},
	watch: {
		filterStream() {
			this.filterStream();
			console.log('filtered');
		}
	},
	async mounted() {

		// Get regions from store (already loaded at app level)
		await this.$store.dispatch('Regions/getRegions', 'list'); // Ensure loaded
		// Use getter and clone to prevent Vuex mutation errors
		this.regions = _.cloneDeep(this.$store.getters['Regions/getRegionsByCategory']('list'));
		// this.filterStream();
	},
	methods: {
		onLegacyModalShow() {
			this.onInit();
			// was @shown="checkSelected" on the old b-modal
			this.checkSelected();
		},
		onLegacyModalHide() {
			this.onDismiss();
		},
		filterStream() {
			let streamCatarray = [];
			this.subscriptions.map((s) => {
				if (s.enabled) streamCatarray.push(_.get(s, ['package', 'category']));
			});

			let streamTypeList = this.streamTypeList;
			if (!streamCatarray.includes('restream')) {
				streamTypeList = [
					{
						type: 'live',
						title: 'Live Stream',
						description: 'Livestream to websites with your player, stream to social media, and convert livestreams to on-demand videos — all in one place',
						description2: 'Livestream videos on your own website and multiple stream destinations.',
						icon: require('@/assets/images/live-plan.svg') // eslint-disable-line no-undef
					},
				];
			}
			return streamTypeList;
		},
		async onInit() {
			if ((this.typeFromBilling != 'restream' && this.typeFromBilling != 'live')) {
				this.operational = true;
				this.error = null;
				this.trialError = null;
				// this.processing = true;
				this.trialProcessing = false;
			}

		},
		onDismiss() {
			this.resetForm();
			this.clearErrors();
			// lazy clear
			setTimeout(() => {
				this.processing = false;
			}, 1000);
		},
		dismiss() {
			this.hideLegacyModal();
			this.onDismiss();
		},
		selectRegion(region) {
			this.selectedRegion = region;
			this.channel.region = region._id;
			this.onInputChange('region');
		},
		getCountryFlag(region) {
			return `https://assets.castr.io/countryflags/${region.identifier}/flat/64.png`;
		},
		selectStreamType(streamType) {
			if (!this.memberPermission && !this.trialProcessing || !(((streamType === 'live') && this.memberPermission && !this.memberPermission.liveStreamManage) || ((streamType === 'restream') && this.memberPermission && !this.memberPermission.recordedStreamManage)) && !this.trialProcessing) {
				this.selectedRegion = null;
				this.channel.region = '';
				if (!this.selectedStreamType) {
					this.selectedStreamType = streamType;
					this.onStreamTypeSelected();
				} else {
					this.unselectStreamType();
					setTimeout(() => {
						this.selectStreamType(streamType);
					}, 250);
				}
			}
		},
		async onStreamTypeSelected() {
			this.operational = true;
			this.error = null;
			this.trialError = null;
			this.trialProcessing = false;

			const subCat = this.selectedStreamType;
			const hasRequiredSub = this.subscriptions.find(
				(s) => {
					const chain = (subCat === 'restream') ? 'package.category' : 'category';
					return _.get(s, chain, '').includes(subCat);
				}
			);
			if (!hasRequiredSub) {
				this.operational = false;
				this.error = { role: true };
			}

			// If client has assigned deployment region for certain stream type
			// we need to show only those regions when creating new stream
			// const platformNode = _.find(this.deploymentRegions, pnode =>
			// 	_.includes(pnode.platforms, subCat)
			// );
			// if (platformNode && !_.isEmpty(platformNode.regions)) {
			// }

			// this.regions = await StreamService.getAvailableRegions(subCat);

			if (this.contextualRegionList.length === 1) {
				this.channel.region = this.contextualRegionList[0]._id;
			}
		},
		unselectStreamType() {
			this.selectedStreamType = null;
			this.resetForm();
			this.clearErrors();
		},
		async forceActivateTrial() {
			this.trialError = null;
			this.trialProcessing = true;

			// activate trial
			const subCat = this.selectedStreamType;
			try {
				await SubscriptionService.requestTrial(subCat);
				// update vuex state
				await this.$store.dispatch('User/loadUser', null, { root: true });
			} catch (e) {
				this.trialError = e;
				return;
			} finally {
				this.trialProcessing = false;
			}

			this.error = null;
			this.operational = true;

			// on trial activated
			if (!this.trialError) {
				track(EVENTS.TRIAL_STARTED, { packCategory: subCat });
				this.$notify({
					group: 'success',
					text: `${this.selectedStreamType} trial activated successfully`
				});
			}
		},
		async onSaveChannel() {
			this.error = null;

			// if selected scheduled, set first region from server list
			const stype = this.selectedStreamType;
			if (stype === 'scheduled') {
				const region = _.head(this.regions.filter(r => r.platforms.indexOf(stype) > -1));
				this.channel.region = region._id;
			}

			if (!this.validateForm()) return;

			this.processing = true;

			try {
				// const stream = await StreamService.addStream(
				await StreamService.addStream(
					this.channel.name,
					this.channel.region,
					this.selectedStreamType
				);

				// #custom-patch: new stream not found in api response
				// Force refresh Vuex store to get newly created stream
				await this.$store.dispatch('Streams/getStreams', true);
				const streamList = this.$store.getters['Streams/streams'];
				const stream = _.find(
					streamList,
					s =>
						s.type === this.selectedStreamType &&
						s.name === this.channel.name
				);
				// --

				track(EVENTS.STREAM_CREATED, {
					streamType: stream?.type || this.selectedStreamType,
					regionName: this.selectedRegion?.name
				});

				this.$emit('new-channel', stream, this.selectedRegion);
				this.dismiss();
			} catch (err) {
				this.error = err;
				this.processing = false;
				this.selectedRegion = null;
				err.message = '<i class="fas fa-exclamation-triangle mr-2"></i>' + err.message;
				if (this.selectedStreamType === 'restream') {
					err.message = err.message.replace('upgrade your subscription', '<a class="upgradelink" target="_blank" href="/app/subscribe?category=restream">upgrade your subscription</a>');
				}
				if (this.selectedStreamType === 'live') {
					err.message = err.message.replace('upgrade your subscription', '<a class="upgradelink" target="_blank" href="/app/subscribe?category=live">upgrade your subscription</a>');
				}
				if (this.selectedStreamType === 'vod') {
					err.message = err.message.replace('streams and platforms', 'VOD Bucket');
				}
				// check if subscripiton error
				if (err && _.indexOf(err.message, 'subscription') > -1) {
					this.error.subscription = true;
				}
			}
		},
		validateForm() {
			const props = ['name', 'region'];

			let valids = 0;
			_.each(props, prop => {
				const val = this.channel[prop];
				if (val) valids++;
				this.formErrors[prop] = !val;
			});

			return valids === props.length;
		},
		clearErrors() {
			this.error = null;
			this.formErrors.name = false;
			this.formErrors.region = false;
		},
		resetForm() {
			this.selectedStreamType = null;
			this.channel.name = null;
		},
		checkSelected() {
			if (this.typeFromBilling === 'restream' || this.typeFromBilling === 'live') {

				this.selectStreamType(this.typeFromBilling);
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.stream-item {
	padding: 16px 26px;
	position: relative;
	/* margin-bottom: 20px; */
	cursor: pointer;
}

.stream-item__desc {
	position: relative;
	flex-grow: 1;
}

.stream-item:not(:last-child) .stream-item__desc:after {
	content: '';
	display: block;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	height: 1px;
	position: absolute;
	left: 0;
	bottom: -15px;
}

.stream-item:hover {
	background-color: var(--c-dark-3);
}

.stream-item.active {
	background-color: var(--c-main-1);
}

.stream-item.active .stream-item__desc:after {
	content: none;
}

.stream-item svg {
	color: var(--c-main-1);
}

.stream-item:hover svg,
.stream-item.active svg {
	color: #fff;
}

.stream-item.active .stream-item__p {
	color: #fff;
}

.stream-item__title {
	font-size: var(--font-s-m);
}

.stream-item__p {
	font-size: var(--font-s-s);
}

/* .hideform {
		display: none;
	}
	.showform {
		display: flex;
	} */
.second-modal {
	position: fixed;
	top: 0;
	background-color: var(--c-dark-2);
	margin: auto;
	width: 400px;
	height: 100%;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
	right: 0;
	z-index: -1;
	border-left: 1px solid var(--c-dark-3);
	border-right: 1px solid var(--c-dark-3);
}

.showform.second-modal {
	right: 414px;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
}

.stream-type-info {
	/* background-color: var(--c-dark-3); */
	padding: 0px;
}

.region-dropdown .dropdown-menu {
	left: -100% !important;
}

.region-flag {
	width: 20px;
}

.modal-logo {
	padding-left: 9px;
}

.stream-type-info h4,
.stream-type-info p {
	cursor: pointer;
}

@media (max-width: 767px) {
	.mobile-header {
		border-radius: 24px 24px 0 0;
		margin-top: 0;
		background-color: var(--c-dark-3);
		border-bottom: 1px solid var(--c-dark-5);
	}

	.hideform.second-modal {
		bottom: -115vh;
		left: 0;
		z-index: 0;
		max-width: 100%;
		transition: opacity 0.3s linear, bottom 0.3s ease-out;
	}

	.showform.second-modal {
		height: auto;
		top: auto;
		bottom: 0;
		left: 0;
		z-index: 1030;
		max-width: 100%;
		transition: opacity 0.3s linear, bottom 0.3s ease-out;
	}

	.modal-logo {
		display: none;
	}

	.modal-title {
		padding: 16px 0;
	}

	.modal-title-style2 {
		display: none;
	}

	.second-modal {
		width: 100%;
		border-left: none;
		border-right: none;
	}

	.btn-close {
		background-color: var(--c-dark-5);
		border-radius: 50%;
		color: var(--c-dark-8);
		height: 32px;
		width: 32px;
	}

	.mt-200 {
		margin-top: 0;
	}

	.stream-item {
		padding: 15px;
	}

	.btn-icon {
		color: var(--c-dark-7);
	}

	:deep(.region-dropdown .dropdown-menu) {
		max-width: 315px;
	}

	:deep(.regions-wrapper) {
		top: -191px;
	}
}

@media (min-width: 768px) and (max-width: 991px) {
	.showform.second-modal {
		right: 100%;
	}
}
</style>
